export const checkMedia = ()=>{
	if(window.innerWidth < 768){
		return 'MOBILE'
	}else if(window.innerWidth <= 1024){
		return 'TABLET'
	}else{
		return 'DESKTOP'
	}
}


// WEBPACK FOOTER //
// ./src/helpers.js